import {Moment} from 'moment'
import {TimeTableTime} from './BusinessScheduleItemInterfaces'
import {HOURS, HOURS_24, RESERVATION_TIME_UNIT_MINUTES} from '../../../../CodeMaster'

export function fromMomentToStartTime(time: Moment): TimeTableTime<HOURS> {
    const hour: HOURS = HOURS.codeToEnumConstants(`${time.hour()}`)
    const minute: RESERVATION_TIME_UNIT_MINUTES =
        RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(`${time.minute()}`)

    return {
        hour: hour,
        minute: minute,
    }
}

export function fromMomentToEndTime(time: Moment): TimeTableTime<HOURS_24> {
    let hour: HOURS_24 = HOURS_24.codeToEnumConstants(`${time.hour()}`)
    const minute: RESERVATION_TIME_UNIT_MINUTES =
        RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(`${time.minute()}`)

    if (hour === HOURS_24.VOL_0 && minute === RESERVATION_TIME_UNIT_MINUTES.VOL_0) {
        hour = HOURS_24.VOL_24
    }

    return {
        hour: hour,
        minute: minute,
    }
}

export function fromMomentToTimeZone(time: Moment): TimeTableTime<HOURS_24> {
    const hour: HOURS_24 = HOURS_24.codeToEnumConstants(`${time.hour()}`)
    const minute: RESERVATION_TIME_UNIT_MINUTES =
        RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(`${time.minute()}`)

    return {
        hour: hour,
        minute: minute,
    }
}
